import script from "./AdviceComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AdviceComponent.vue?vue&type=script&setup=true&lang=js"

import "./AdviceComponent.vue?vue&type=style&index=0&id=ac8f9bbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac8f9bbe"]])

export default __exports__